export default __webpack_public_path__ + "static/media/ic_vtb.a1228b63.svg";